import { render, staticRenderFns } from "./asx.vue?vue&type=template&id=51e6b476&scoped=true"
import script from "./asx.vue?vue&type=script&lang=js"
export * from "./asx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e6b476",
  null
  
)

export default component.exports